import React from 'react';
import { useSelector } from 'react-redux';
import { useRenderNoInfo } from 'utils/commonUtils';
import { TitleTypography } from 'components/Ui/styled';
import { ListItemWrap, StatusDot } from '../dashboardStyled';
import { cardListColors, NO_ANNOUNCEMENTS_TEXT } from 'constants';
import { SafeQuillHtml } from 'components/Common/SafeQuillHtml';

const DashboardAnnouncements = () => {
  const announcements = useSelector((state) => state.dashboard.announcements);
  const noInfoComponent = useRenderNoInfo(
    announcements,
    NO_ANNOUNCEMENTS_TEXT,
  );

  return (
    <>
      {noInfoComponent}
      {announcements?.map((item, index) => {
        const { msg } = item;
        const dotColor = cardListColors[index % cardListColors.length];
        return (
          <ListItemWrap key={index}>
            <StatusDot bgcolor={dotColor} />
            <TitleTypography>
              <SafeQuillHtml html={msg} />
            </TitleTypography>
          </ListItemWrap>
        );
      })}
    </>
  );
};

export default DashboardAnnouncements;
